export default {
  terms: {
    title: '利用規約',
    effectiveDate: '施行日：2024 年 3 月 15 日',
    intro:
      'PhotoScope へようこそ。PhotoScope は AI 搭載のビジュアル学習ツールです。自分の写真と選んだ参考画像を比較することで写真の視覚的スタイルを理解し、その違いを説明するとともに、あなた自身の現像の方向性を提案します。本利用規約（以下「規約」）は、PhotoScope の利用に関するお客様の権利と責任を定めるものです。',
    sections: [
      {
        heading: '1. 規約の同意',
        body: [
          'アカウントを作成または PhotoScope を利用することで、お客様は本規約およびプライバシーポリシーに拘束されることに同意したものとみなします。同意いただけない場合は、本サービスをご利用にならないでください。',
        ],
      },
      {
        heading: '2. サービスの説明',
        body: [
          'PhotoScope では、写真をアップロードし、参考画像を選択します。私たちは両者の視覚的な差（トーン、色、彩度、構図など）を分析し、AI が生成した解説と調整のヒントを提供します。',
          'PhotoScope は学習・理解のためのツールです。写真を理解し、ご自身の判断力を養うことを目的としており、自動現像ツールやレタッチサービスではなく、また参考画像を再現できることを保証するものでもありません。',
          '機能、モデル、分析方法は随時更新される場合があります。プレビュー、グラフ、ヒントは学習目的で提供されており、予告なく変更されることがあります。',
        ],
      },
      {
        heading: '3. 利用資格',
        body: [
          'PhotoScope をご利用いただくには 13 歳以上である必要があります。本サービスを利用することで、お客様はこの年齢要件を満たし、本規約に同意する能力を有することを表明し、保証するものとします。',
        ],
      },
      {
        heading: '4. アカウントと第三者によるサインイン',
        body: [
          'メールアドレスで PhotoScope アカウントを作成するか、Google などの第三者プロバイダーでサインインできます。第三者サインインを利用する場合、お客様の利用は当該プロバイダーの規約にも従うものとします。',
          'アカウントの認証情報の秘密保持およびアカウント下で行われるすべての活動についての責任はお客様にあります。不正アクセスを疑う場合は、直ちにご連絡ください。',
        ],
      },
      {
        heading: '5. クレジットと課金',
        body: [
          'PhotoScope の一部機能はクレジット制です。アカウントには無料クレジットとご購入いただいたクレジットが含まれる場合があります。',
          '一回限りで購入したクレジットには有効期限があり、購入時およびダッシュボードに表示されます。未使用のクレジットは有効期限日に失効し、自動的に更新されることはありません。',
          'クレジットの価格は購入時の表示に基づき、変更される場合があります。価格の変更は将来の購入にのみ適用され、既に購入したクレジットには影響しません。',
          '法律で義務付けられている場合を除き、購入したクレジットの返金はいたしません。請求に関するご質問はお問い合わせください。確認いたします。',
        ],
        items: [
          'クレジットの残高と有効期限は、いつでもダッシュボードで確認できます。',
          'プロモーションやボーナスクレジットを発行する場合があります。これらには付与時に別途示される条件が適用される場合があります。',
        ],
      },
      {
        heading: '6. お客様のコンテンツと参考画像',
        body: [
          'ご自身の写真（「お客様のコンテンツ」）と参考画像をアップロードできます。お客様はお客様のコンテンツの所有権を保持します。アップロードにより、お客様はサービスの提供および改善のみを目的として、当該コンテンツを処理・分析・保存するための限定的かつ非独占的でロイヤリティフリーのライセンスを PhotoScope に付与するものとします。',
          'お客様は、お客様のコンテンツおよび任意の参考画像をアップロードする権利を有し、第三者の権利を侵害せず適用される法律に違反しないことを表明し、保証するものとします。',
        ],
      },
      {
        heading: '7. 適正な利用',
        body: [
          'お客様は PhotoScope を合法的目的にのみ利用することに同意するものとします。特に、以下を行ってはなりません。',
        ],
        items: [
          '第三者のプライバシーや知的財産を侵害する画像など、違法・権利侵害・有害なコンテンツのアップロード。',
          'リバースエンジニアリング、本サービスの妨害または過負荷、システムへの不正アクセスの試み。',
          '競合製品の構築、または大規模な出力のスクレイピング目的での本サービスの利用。',
        ],
      },
      {
        heading: '8. 知的財産権',
        body: [
          'PhotoScope のソフトウェア、デザイン、商標、および分析結果（お客様ご自身の入力を除く）は、当社または当社のライセンス提供者に帰属します。事前の書面による許可なくこれらを利用することはできません。',
          'AI が生成した解説、グラフ、ヒントは、お客様個人の学習および現像のために提供され、いかなる参考画像の所有権もお客様に移転するものではありません。',
        ],
      },
      {
        heading: '9. AI 生成コンテンツと免責事項',
        body: [
          'PhotoScope は人工知能を用いて解説、差の分析、調整のヒントを生成します。これらの出力は視覚データと写真の原理に基づくガイダンスであり、プロの写真、現像、またはその他の専門的な助言ではありません。',
          'いかなるヒントも正確・完全であること、またお客様の特定の写真や意図に適していることを保証するものではありません。現像に関する決定および作成・共有する最終的な画像についての責任はお客様にあります。',
          '法令で認められる最大限の範囲で、本サービスは「現状有姿」で提供され、いかなる種類の保証も伴いません。',
        ],
      },
      {
        heading: '10. 責任の制限',
        body: [
          '法令で認められる最大限の範囲で、PhotoScope は、本サービスの利用に起因する間接的、偶発的、または結果的な損害（データの喪失や AI のヒントに基づく決定による損害を含む）について責任を負いません。',
        ],
      },
      {
        heading: '11. 終了',
        body: [
          '本規約に違反または本サービスを濫用した場合、当社はお客様のアクセスを停止または終了することができます。お客様はいつでも PhotoScope の利用を中止できます。終了後、本サービスを利用する権利は直ちに消滅します。',
        ],
      },
      {
        heading: '12. 規約の変更',
        body: [
          '本規約は随時更新される場合があります。更新版は新しい施行日とともに掲載されます。変更後の継続利用は、更新された規約への同意を意味します。',
        ],
      },
      {
        heading: '13. 準拠法',
        body: [
          '本規約はアメリカ合衆国の法律に準拠します。紛争はアメリカ合衆国の裁判所で解決されます。他の地域に所在する場合でも、現地の法律の遵守責任はお客様にあります。',
        ],
      },
      {
        heading: '14. お問い合わせ',
        body: [
          '本規約に関するご質問は、info@photoscope.cc までお問い合わせください。',
        ],
      },
    ],
  },
  privacy: {
    title: 'プライバシーポリシー',
    effectiveDate: '施行日：2024 年 3 月 15 日',
    intro:
      '本プライバシーポリシーは、PhotoScope がどのような情報を収集し、どのように利用するか、およびお客様が持つ選択肢を説明するものです。PhotoScope は AI ビジュアル学習ツールです。写真と参考画像をアップロードすると、両者の視覚的な差を分析し、学習をお手伝いします。',
    sections: [
      {
        heading: '1. 収集する情報',
        body: [],
        sub: [
          {
            heading: '1.1 アカウント情報',
            body: [
              '登録時、氏名、メールアドレス、アカウント詳細を収集します。Google などのプロバイダーでサインインする場合、当該プロバイダーが共有するアカウント識別子と基本プロフィール情報を受け取ります。',
            ],
          },
          {
            heading: '1.2 画像と参考画像',
            body: [
              'アップロードした写真、選択した参考画像、および分析に必要な技術的メタデータ（寸法など）を収集します。',
            ],
          },
          {
            heading: '1.3 利用およびデバイスデータ',
            body: [
              'IP アドレス、ブラウザの種類、デバイス情報、利用機能に関する分析など、PhotoScope の利用方法に関する情報を収集します。これによりサービスの運営と改善を行います。',
            ],
          },
        ],
      },
      {
        heading: '2. 画像の処理方法',
        body: [
          '分析を生成するため、お客様の画像はデバイス側の技術（ブラウザ内のローカル画像分析など）および必要に応じてクラウド上の AI サービスによって処理されます。参考画像は、ご指定の比較における視覚スタイルの差を計算するためのみに使用されます。',
          'お客様の画像は、ご依頼の分析の提供および履歴の維持のみを目的として利用します。お客様の個人的な写真を別途の同意なく公開モデルの学習に使用することはありません。',
        ],
      },
      {
        heading: '3. 情報の利用目的',
        body: [
          'お客様の情報は次の目的で利用します。',
        ],
        items: [
          'PhotoScope の提供、運営、改善。',
          'アップロードされた画像の処理と分析。',
          'アカウント、更新、サポートに関するご連絡。',
          'サービスの安全保障および濫用の防止。',
        ],
      },
      {
        heading: '4. 情報の共有と開示',
        body: [
          'お客様の個人情報を販売することはありません。ただし、以下の場合に共有することがあります。',
        ],
        items: [
          'クラウドホスティング、AI 処理、分析パートナーなど、PhotoScope を運営するサービスプロバイダー（適切な保護措置の下で）。',
          '法令に基づく要求、または当社およびユーザーの権利を保護するための当局への提供。',
          'お客様を識別できない集計または匿名化されたデータ（分析および製品改善のため）。',
        ],
      },
      {
        heading: '5. Cookie と追跡技術',
        body: [
          'ログイン状態の維持、設定の記憶、利用状況の把握のため、Cookie および類似技術を使用します。Cookie はブラウザの設定で管理できます。',
        ],
      },
      {
        heading: '6. データセキュリティ',
        body: [
          '業界標準の措置を用いてお客様の情報を保護します。ただし、いかなるシステムも完全に安全というわけではありません。慎重にご利用いただき、アカウントの認証情報を保護してください。',
        ],
      },
      {
        heading: '7. データの保持と削除',
        body: [
          '情報は必要な期間のみ保持します。',
        ],
        items: [
          'アカウントデータ：アカウントが有効な間保持。',
          'アップロードされた画像と分析結果：サービスと履歴の提供のため保持され、アカウント削除または削除リクエスト時に削除されます。',
          'データの削除はお問い合わせでご請求いただけます。確認可能なリクエストには合理的な期間内に対応します。',
        ],
      },
      {
        heading: '8. お客様の権利',
        body: [
          'お住まいの地域により、個人データへのアクセス、訂正、削除、ポータビリティの権利、および特定の処理への異議申立てやオプトアウトの権利を有する場合があります。これらの権利を行使するにはお問い合わせください。適用される法律（GDPR や CCPA など）に従い対応します。',
        ],
      },
      {
        heading: '9. 児童のプライバシー',
        body: [
          'PhotoScope は 13 歳未満のお子様を対象としていません。13 歳未満のお子様の個人情報を意図的に収集することはありません。',
        ],
      },
      {
        heading: '10. 国際的なデータ転送',
        body: [
          'PhotoScope は、アメリカ合衆国を含むお客様の国以外のサーバーでデータを処理する場合があります。国境を越える個人データの転送には適切な保護措置を講じます。',
        ],
      },
      {
        heading: '11. ポリシーの変更',
        body: [
          '本プライバシーポリシーは随時更新される場合があります。新しい施行日を付して掲載されます。重要な変更はウェブサイトを通じてお知らせします。',
        ],
      },
      {
        heading: '12. お問い合わせ',
        body: [
          'プライバシーに関するご質問は、info@photoscope.cc までお問い合わせください。',
        ],
      },
    ],
  },
};
